export default "__VITE_ASSET__XKrd65bWbFkOtoRuFyGqUA__";